import {createReducer, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import * as symbolActions from '../_actions/symbol.actions';
import {DrawSymbol} from '../_interface/symbol.model';

export const symbolsFeatureKey = 'symbols';

export interface SymbolEntityState extends EntityState<DrawSymbol> {
	edit: Partial<DrawSymbol> | null;
	loaded: boolean;
}

export const adapter: EntityAdapter<DrawSymbol> = createEntityAdapter<DrawSymbol>(
	{selectId: model => model.symbolId}
);

export const initialState: SymbolEntityState = adapter.getInitialState({
	edit: null,
	loaded: false
});


export const reducer = createReducer(
	initialState,
	on(symbolActions.setSymbolForEdit,
		(state, {symbol}) => ({
			...state,
			edit: {
				...symbol
			}
		})
	),
	on(symbolActions.cancelSymbolForEdit,
		(state) => ({
			...state,
			edit: null
		})
	),
	on(symbolActions.addSymbol,
		(state, action) => adapter.addOne(action.symbol, state)
	),
	on(symbolActions.upsertSymbol,
		(state, action) => adapter.upsertOne(action.symbol, {...state, edit: null})
	),
	on(symbolActions.addSymbols,
		(state, action) => adapter.addMany(action.symbols, state)
	),
	on(symbolActions.upsertSymbols,
		(state, action) => adapter.upsertMany(action.symbols, state)
	),
	on(symbolActions.updateSymbol,
		(state, action) => adapter.updateOne(action.symbol, state)
	),
	on(symbolActions.updateSymbols,
		(state, action) => adapter.updateMany(action.symbols, state)
	),
	on(symbolActions.deleteSymbol,
		(state, {symbolId}) => adapter.removeOne(symbolId, state)
	),
	on(symbolActions.deleteSymbols,
		(state, action) => adapter.removeMany(action.ids, state)
	),
	on(symbolActions.loadSymbols,
		(state, action) => adapter.setAll(action.symbols, {...state, loaded: true})
	),
	on(symbolActions.clearSymbols,
		state => adapter.removeAll(state)
	),
);


export const {
	selectIds,
	selectEntities,
	selectAll,
	selectTotal,
} = adapter.getSelectors();
